import { render, staticRenderFns } from "./Done.vue?vue&type=template&id=0a2a4972"
import script from "./Done.vue?vue&type=script&lang=js"
export * from "./Done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports